import ChangePasswordDialogComponent from './change-password.component'

const ChangePasswordDialogModule = angular.module('cdbl.account-change-password', [

])
  .component('cdblAccountChangePassword', ChangePasswordDialogComponent)
  .name

export default ChangePasswordDialogModule
